(() => {
  const initFeatureGrid = (container) => {
    if (!container || container.dataset.featureGridInitialized === 'true') return;
    container.dataset.featureGridInitialized = 'true';

    const cards = container.querySelectorAll('.feature-card');
    const firstCard = container.querySelector('.feature-card');
    const desktopGrid = container.querySelector('.feature-grid-container');

    cards.forEach((card) => {
      card.addEventListener('mouseenter', () => {
        cards.forEach((item) => {
          item.classList.remove('feature-card-last', 'is-expanded');
        });
        card.classList.add('is-expanded');
      });

      card.addEventListener('mouseleave', (event) => {
        if (!container.contains(event.relatedTarget)) {
          cards.forEach((item) => item.classList.remove('is-expanded'));
          firstCard?.classList.add('feature-card-last');
        }
      });
    });

    desktopGrid?.addEventListener('mouseleave', () => {
      cards.forEach((item) => item.classList.remove('is-expanded'));
      firstCard?.classList.add('feature-card-last');
    });

    const setupCarousel = (selector, cardSelector) => {
      const carousel = container.querySelector(selector);
      if (!carousel) return;

      const scrollContainer = carousel.querySelector(`${selector}-scroll`);
      const prevBtn = carousel.querySelector('.feature-grid-nav-prev');
      const nextBtn = carousel.querySelector('.feature-grid-nav-next');
      if (!scrollContainer || !prevBtn || !nextBtn) return;

      const scrollOne = (direction) => {
        const card = scrollContainer.querySelector(cardSelector);
        if (!card) return;
        const styles = getComputedStyle(scrollContainer);
        const gap = parseFloat(styles.columnGap || styles.gap || '0');
        scrollContainer.scrollBy({
          left: direction * (card.getBoundingClientRect().width + gap),
          behavior: 'smooth'
        });
      };

      prevBtn.addEventListener('click', () => scrollOne(-1));
      nextBtn.addEventListener('click', () => scrollOne(1));
    };

    setupCarousel('.feature-grid-tablet', '.feature-card-tablet');
    setupCarousel('.feature-grid-mobile', '.feature-card-mobile');

    const updateAspectRatio = () => {
      const screenWidth = window.innerWidth;
      const tabletCards = container.querySelectorAll('.feature-card-tablet');
      const mobileCards = container.querySelectorAll('.feature-card-mobile');

      if (screenWidth > 768 && screenWidth <= 1024) {
        tabletCards.forEach((card) => { card.style.aspectRatio = '1 / 1'; });
      } else {
        tabletCards.forEach((card) => { card.style.aspectRatio = ''; });
      }

      if (screenWidth <= 768) {
        const ratio = Math.max(
          27 / 40,
          Math.min(47 / 40, ((screenWidth - 300) / (768 - 300)) * (47 / 40 - 27 / 40) + 27 / 40)
        );
        mobileCards.forEach((card) => { card.style.aspectRatio = String(ratio); });
      } else {
        mobileCards.forEach((card) => { card.style.aspectRatio = ''; });
      }
    };

    updateAspectRatio();
    const onResize = () => requestAnimationFrame(updateAspectRatio);
    window.addEventListener('resize', onResize, { passive: true });
  };

  const initAll = (root = document) => {
    root.querySelectorAll('[data-feature-grid]').forEach(initFeatureGrid);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
